import { render, staticRenderFns } from "./MilestoneWizard.vue?vue&type=template&id=481d1192&scoped=true&"
import script from "./MilestoneWizard.vue?vue&type=script&lang=js&"
export * from "./MilestoneWizard.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneWizard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MilestoneWizard.vue?vue&type=style&index=1&id=481d1192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d1192",
  null
  
)

export default component.exports